import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class GeneralService {

    className = 'GeneralService'

    constructor(private http: HttpClient) {

    }

    get(url) {
        return this.http.get(url);
    }
}